export default "__VITE_ASSET__B21zxRy6__"